import * as React from 'react';
import { connect } from 'react-redux';
import { languages } from '../helpers/util';
import { appActions } from '../store/ducks/app';
import { LinkGray } from '../components/styled';

const mapStateToProps = (state: any) => ({
  language: state.appData.language,
});
type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  changeLanguage: (language: string) => any;
}
type Props = StateProps & DispatchProps;
class Footer extends React.Component<Props> {
  render() {
    return (
      <footer>
        {
          Object.keys(languages).map((key: string) => (
            <LinkGray
              key={key}
              className={this.props.language === key ? 'active' : ''}
              onClick={() => this.props.changeLanguage(key)}
            >
              { languages[key] }
            </LinkGray>
          ))
        }
      </footer>
    );
  }
}

export default connect<StateProps, DispatchProps>(mapStateToProps, appActions)(Footer);
